module.exports = {
      id: "follow-facebook-usage",
      viewBox: "0 0 29 28",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#follow-facebook",
      toString: function () {
        return this.url;
      }
    }